import './App.css';
// import Calculator from './Components/Calculator';
import StopWatch from './Components/StopWatch';

function App() {
  return (
    // <Calculator/>
    <StopWatch/>
  );
}

export default App;
